import {Grid} from '@logistics-frontend/blocks'
import React from 'react'

import {DeliveryDateSelect} from '../../DeliveryDateSelect/DeliveryDateSelect'
import {DeliveryIntervalSelect} from '../../DeliveryIntervalSelect/DeliveryIntervalSelect'
import {useDeliveryIntervals} from './hooks'

export function DeliveryIntervals(): React.ReactElement {
  const {dateList, intervalList} = useDeliveryIntervals()

  return (
    <Grid size="s" container>
      <Grid item xs>
        <DeliveryDateSelect dates={dateList} name={'offerFlow.deliveryDate'} />
      </Grid>
      <Grid item xs>
        <DeliveryIntervalSelect intervals={intervalList} name={'offerFlow.deliveryInterval'} />
      </Grid>
    </Grid>
  )
}
